// extracted by mini-css-extract-plugin
export var link = "_uu-0";